import { createSlice } from "@reduxjs/toolkit";
// import interlineJson from "../../../../../../../interlineNotCheckedin.json";
// import multiCityJson from "../../../../../../../../Downloads/Multicity.json"

const initialState = {
  checkinDetails: [],
  isLoading: false,
  hasData: false,
  checkInSuccess: false,
  checkinPnr: {},
  selectedJourney: [],
  headerData: {},
  selectedFlight: {},
  error: "",
  completeCheckin: {},
  insuranceData: {},
  pageName: "",
  flightDetails: {},
  policyNumber: {},
  boardingPassRequest: {},
  paymentType: {},
  tripType: "",
  travelReadyData: {}
};
const fetchCheckInSlice = createSlice({
  name: "checkin",
  initialState,
  reducers: {
    retrieveJourneyRequest: (state, action) => {
      state.isLoading = true;
      state.checkInSuccess = false;
      state.error = "";
    },
    retrieveJourneySuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.checkInSuccess = true;
      state.checkinDetails = action.payload;
    },
    retrieveJourneyFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload.response.data.errors;
      state.checkInSuccess = false;
      state.checkinDetails = [];
    },
    resetJourneyDetails: state => {
      state.isLoading = false;
      state.checkinDetails = [];
      state.checkInSuccess = false;
      state.hasData = false;
      state.completeCheckin = {};
      state.flightDetails = {};
      state.error = "";
    },
    resetError: state => {
      state.error = "";
    },
    setPNRandLastName: (state, action) => {
      state.checkinPnr = action.payload;
    },
    setFlightId: (state, action) => {
      state.selectedFlight = action.payload;
    },
    resetPNRDetails: state => {
      state.checkinPnr = {};
    },
    resetFlightId: state => {
      state.selectedFlight = {};
    },
    updateJourneyResponse: (state, action) => {
      state.checkinDetails = state?.checkinDetails?.map(item => item?.id === action?.payload?.id ? {
        ...item,
        ...action.payload
      } : item);
    },
    setHeaderData: (state, action) => {
      state.headerData = action.payload;
    },
    setCompletecheckinDataLayer: (state, action) => {
      state.completeCheckin = action.payload;
    },
    setInsuranceData: (state, action) => {
      state.insuranceData = action.payload;
    },
    resetInsuranceData: state => {
      state.insuranceData = {};
    },
    setPageName: (state, action) => {
      state.pageName = action.payload;
    },
    resetPageName: state => {
      state.pageName = "";
    },
    setFlightDetails: (state, action) => {
      state.flightDetails = action.payload;
    },
    setPolicyNumber: (state, action) => {
      state.policyNumber = action.payload;
    },
    resetPolicyNumber: (state, action) => {
      state.policyNumber = "";
    },
    setBoardingPassRequest: (state, action) => {
      state.boardingPassRequest = action.payload;
    },
    resetBoardingPassRequest: state => {
      state.boardingPassRequest = {};
    },
    setPaymentType: (state, action) => {
      state.paymentType = action.payload;
    },
    resetPaymentType: state => {
      state.paymentType = {};
    },
    setTripType: (state, action) => {
      state.tripType = action.payload;
    },
    resetTripType: state => {
      state.tripType = "";
    },
    setTravelReadyData: (state, action) => {
      state.travelReadyData = action.payload;
    },
    resetTravelReadyData: state => {
      state.travelReadyData = {};
    }
  }
});
export const {
  retrieveJourneyRequest,
  retrieveJourneySuccess,
  retrieveJourneyFailure,
  resetJourneyDetails,
  resetPNRDetails,
  setPNRandLastName,
  updateJourneyResponse,
  setHeaderData,
  setFlightId,
  resetFlightId,
  setCompletecheckinDataLayer,
  setInsuranceData,
  setPageName,
  resetPageName,
  resetInsuranceData,
  setFlightDetails,
  resetError,
  setPolicyNumber,
  resetPolicyNumber,
  setBoardingPassRequest,
  resetBoardingPassRequest,
  setPaymentType,
  resetPaymentType,
  setTripType,
  resetTripType,
  setTravelReadyData,
  resetTravelReadyData
} = fetchCheckInSlice.actions;
export default fetchCheckInSlice.reducer;